"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_1 = require("react-router");
var AGgrid_table_component_1 = require("../../../../common/tables/AGgrid_table_component");
var route_path_1 = require("../../../../constants/route_path");
var table_data_1 = require("../../../../constants/table_data");
var menu_constants_1 = require("../../../../menuList/menu_constants");
var array_helpers_1 = require("../../../../utils/array_helpers");
var approvals_helper_1 = require("./approvals_helper");
var LevelTwoPendingApproval = function (_a) {
    var searchTerm = _a.searchTerm, isDateRangeUpdated = _a.isDateRangeUpdated, isFilterButton = _a.isFilterButton;
    var nav = (0, react_router_1.useNavigate)();
    var _b = React.useState(undefined), pendingList = _b[0], setPendingList = _b[1];
    var _c = React.useState(), errorMessage = _c[0], setErrorMessage = _c[1];
    var features = (0, array_helpers_1.getAccessibleFeatures)(menu_constants_1.FEATURE_CONSTANTS.approvals);
    console.log(features);
    var onRowClickedHandler = function (event) {
        nav("/".concat(route_path_1.default.PATHS.approvals, "/").concat(route_path_1.default.PATHS.fe, "/").concat(route_path_1.default.PATHS.feLevelTwoDetails, "/").concat(event.data.id, "/").concat(event.data.onboard_status));
    };
    var getPendingList = function (payload) {
        (0, approvals_helper_1.levelTwoPendingList)(payload)
            .then(function (response) {
            var data = (0, array_helpers_1.approvalsResponseConverter)(response);
            setPendingList(data);
            setErrorMessage('');
        })
            .catch(function (err) {
            setErrorMessage(err.message);
            setPendingList([]);
        });
    };
    React.useEffect(function () {
        console.log(' searchTerm inside useEffect:', searchTerm);
        var payload = {};
        if (searchTerm) {
            payload['fe_name'] = searchTerm;
        }
        getPendingList(payload);
    }, [isFilterButton]);
    return (React.createElement("div", { className: "fe-wrapper custom-pagination-table clickable-row" },
        React.createElement(AGgrid_table_component_1.default, { isSortable: true, columnDefs: table_data_1.default.SUPER_ADMIN_APPROVAL_LIST_COLUMN, rows: pendingList, errorMessage: errorMessage, onRowClicked: onRowClickedHandler, pagination: false, className: 'approvals-table' })));
};
exports.default = LevelTwoPendingApproval;
